import { DependencyList, useEffect } from 'react'

/**
 * A function that returns `true` if the current component is still mounted. If the component has
 * unmounted, this function will return `false`
 */
export type MountCheckFn = () => boolean
export type Effect = (mountedFn: MountCheckFn) => Promise<void>

export type AsyncEffect = {
  (effect: Effect, destroy: () => void, depList?: DependencyList): void
  (effect: Effect, depList?: DependencyList): void
}

const useAsyncEffect: AsyncEffect = (effect, destroy, depList?: DependencyList) => {
  const dependencies: DependencyList | undefined = Array.isArray(destroy) ? destroy : depList
  useEffect(() => {
    let result
    let mounted = true
    const maybePromise = effect(() => mounted)
    Promise.resolve(maybePromise).then((value) => {
      result = value
    })

    return () => {
      mounted = false
      if (typeof destroy === 'function') destroy(result)
    }
  }, dependencies)
}

export default useAsyncEffect
